/* ============================================================
   Healing Waves — shared interactions
   - reveal-on-scroll (.rv -> .in, honours data-delay)
   - sticky nav background on scroll (header[data-hw-header])
   - rotating announcement ([data-hw-ann] cycles its children)
   Section-specific behaviour (element selector, reviews carousel)
   lives in its own section <script>.
   ============================================================ */
(function () {
  function initReveal() {
    var els = document.querySelectorAll('.hw .rv');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var el = e.target;
          var d = parseInt(el.getAttribute('data-delay') || '0', 10);
          setTimeout(function () { el.classList.add('in'); }, d);
          io.unobserve(el);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initNav() {
    var header = document.querySelector('[data-hw-header]');
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 80) header.classList.add('hw-scrolled');
      else header.classList.remove('hw-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initAnnouncement() {
    document.querySelectorAll('[data-hw-ann]').forEach(function (wrap) {
      var items = wrap.querySelectorAll('[data-hw-ann-item]');
      if (items.length < 2) return;
      var i = 0;
      items.forEach(function (el, idx) { el.style.opacity = idx === 0 ? '1' : '0'; });
      setInterval(function () {
        items[i].style.opacity = '0';
        i = (i + 1) % items.length;
        items[i].style.opacity = '1';
      }, 5000);
    });
  }

  function hwMoney(cents) { return '$' + (cents / 100).toFixed(2); }

  function initCartDrawer() {
    var root = document.querySelector('[data-hw-drawer-root]');
    if (!root) return;
    var overlay = root.querySelector('[data-hw-drawer-overlay]');
    var drawer = root.querySelector('[data-hw-drawer]');
    var itemsEl = root.querySelector('[data-hw-drawer-items]');
    var footEl = root.querySelector('[data-hw-drawer-foot]');
    var subEl = root.querySelector('[data-hw-drawer-subtotal]');

    function open() {
      overlay.hidden = false;
      requestAnimationFrame(function () { overlay.classList.add('is-open'); drawer.classList.add('is-open'); });
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      overlay.classList.remove('is-open'); drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
      setTimeout(function () { overlay.hidden = true; }, 320);
    }
    function updateBadges(count) {
      document.querySelectorAll('[data-hw-cart-count]').forEach(function (b) {
        b.textContent = count; b.style.display = count > 0 ? '' : 'none';
      });
    }
    function esc(s) { return (s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function render(cart) {
      updateBadges(cart.item_count);
      if (!cart.items || !cart.items.length) {
        itemsEl.innerHTML = '<div class="hw-drawer-empty">Your cart is empty.</div>';
        footEl.hidden = true; return;
      }
      footEl.hidden = false;
      subEl.textContent = hwMoney(cart.total_price);
      itemsEl.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + it.image + '" alt="' + esc(it.product_title) + '">' : '';
        return '<div class="hw-drawer-line" data-key="' + it.key + '">'
          + '<a class="hw-drawer-thumb" href="' + it.url + '">' + img + '</a>'
          + '<div><div class="hwdisp" style="font-size:15px">' + esc(it.product_title) + '</div>'
          + '<div style="font-size:12px;color:rgba(26,26,26,0.55);margin-top:3px">' + hwMoney(it.final_price) + ' each</div>'
          + '<div class="hw-drawer-qty"><button type="button" data-hw-dec aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-hw-inc aria-label="Increase">+</button>'
          + '<button type="button" class="hw-drawer-remove" data-hw-remove>Remove</button></div></div>'
          + '<div style="font-weight:600;font-size:14px">' + hwMoney(it.final_line_price) + '</div>'
          + '</div>';
      }).join('');
    }
    function refresh(openAfter) {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart); if (openAfter) open(); return cart; });
    }
    function change(key, qty) {
      return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(function (cart) { render(cart); return cart; });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form.matches && form.matches('form[action*="/cart/add"]'))) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      var orig = btn ? btn.innerHTML : null;
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return refresh(true); })
        .catch(function () { form.submit(); })
        .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = orig; } });
    });

    document.querySelectorAll('[data-hw-cart-toggle]').forEach(function (t) {
      t.addEventListener('click', function (e) { e.preventDefault(); refresh(true); });
    });
    itemsEl.addEventListener('click', function (e) {
      var line = e.target.closest('[data-key]'); if (!line) return;
      var key = line.getAttribute('data-key');
      var span = line.querySelector('.hw-drawer-qty span');
      var q = parseInt(span ? span.textContent : '1', 10);
      if (e.target.closest('[data-hw-remove]')) change(key, 0);
      else if (e.target.closest('[data-hw-inc]')) change(key, q + 1);
      else if (e.target.closest('[data-hw-dec]')) change(key, Math.max(0, q - 1));
    });
    overlay.addEventListener('click', close);
    root.querySelectorAll('[data-hw-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    refresh(false);
  }

  function boot() { initReveal(); initNav(); initAnnouncement(); initCartDrawer(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
